import { useDispatch } from 'react-redux';

import type { AppDispatch } from './models';

export const useAppDispatch = () => useDispatch<AppDispatch>();
